<template>
  <div class="row">
    <div class="col-md-12">
      <button class="btn btn-primary w-auto mb-1">
        Add Document
      </button>
      <div class="card">
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="complianceDocuments"
              :fields="document_field"
              :items-per-page="small ? 10 : 5"
              pagination
              sorter
              tableFilter
            >
              <template #created_at="{ item }">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template>
              <template #status="{ item }">
                <td class="table--action-mobile">
                  <span
                    class="badge"
                    :class="{
                      'badge-success': item.status === 'approved',
                      'badge-danger': item.status === 'rejected',
                      'badge-warning': item.status === 'pending'
                    }"
                  >
                    {{ item.status }}
                  </span>
                </td>
              </template>
              <template #action="{ item }">
                <td class="table--action-mobile">
                  <!-- view button -->
                  <button
                    class="button btn-primary"
                    @click="viewDocument(item)"
                  >
                    View
                  </button>
                  <button
                    v-if="item.status === 'pending'"
                    class="button btn-success"
                    @click="treatDocument(item)"
                  >
                    Treat Document
                  </button>
                </td>
              </template>
            </CDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CModal from "@/components/CModal.vue";
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";    
const document_field = [
  "title",
  "description",
  "status",
  "date",
  "action"  
];
export default {
  props:{
    reference : {
        requrequired: false
    }
  },
  components: {
    CModal,
    CDataTable
  },
  data() {
    return {
      complianceDocuments: [
        {
          title: "Operational License",
          description: "Money Lending License",
          status: "pending",
          date: "2023-10-01"
        },
        {
          title: "CAC",
          description: "Corporate Affairs Commission Document",
          status: "approved",
          date: "2023-10-02"
        },
        {
          title: "Shareholding Agreement",
          description: "Shareholding Agreement Document",
          status: "rejected",
          date: "2023-10-03"
        }
      ],
      next_page: 1,
      current: 1,
      total: 1,
    };
  },
  methods:{
    treatDocument(document){

    },
    viewDocument(document){

    },
    async getDocuments(page){
        if (!this.can("documents")) {
            return;
        }
        try {
            const response = ApiService.get(`documents/all?page=${page}`)
            this.complianceDocuments = response.data.data
            this.current = response.data.data.current_page;
            this.total = response.data.data.last_page;
        } catch (error) {
            
        }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        console.log(this.next_page);
        if (this.error_status == false) {
          this.getDocuments(this.next_page);
        }
      }
    },
  },
  mounted() {
    this.getDocuments()
  },
};
</script>

<style></style>
